import React from 'react';
import { IconButton, Typography } from '@material-ui/core';
import { TFunction } from 'i18next';
import { ColumnProps } from 'components/@common/Table/LwtTable';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import {
  appendSecondsOrFallback,
  hasJsonResponse
} from 'components/ReportsModule/components/KeyboardingReport/keyboarding-report-util';

const Title = ({ children }: any) => (
  <Typography style={{ fontSize: 12, fontWeight: 600 }}>{children}</Typography>
);
const getDefault = (value: any) => {
  // if (value === undefined) return 'N/A';
  if (!value) return '-';
  return value;
};
const NoTriesIcon = ({ current = 0, prev = 0 }) => {
  if (current === prev) return <></>;
  if (current < prev) return <ArrowUpwardIcon style={{ color: '#4DA367' }} />;
  if (current > prev) return <ArrowDownward style={{ color: '#DB1F64' }} />;
  return <></>;
};

const filterSingleAttempt = (data: any[], activityKey: string) => {
  const filterValues = [`${activityKey}_timeToAnswer`, `${activityKey}_noOfTries`];
  const result = data.filter((x: any) => !filterValues.includes(x.id));

  return result;
};

const getColumns: (
  t: TFunction,
  handleIconClick: (data: any) => void,
  hasOneAttempt: boolean,
  activityKey: any
) => ColumnProps<any>[] = (
  t: TFunction,
  handleIconClick: (data: any) => void,
  hasOneAttempt: boolean,
  activityKey
) => {
  // if more than 1 attempts, need to split the columns by the last 2

  const main: ColumnProps<any> = {
    id: 'a1_question',
    label: <Title>{t('Question')}</Title>,
    sortKey: 'a1_question',
    getValue: item => <Typography>{item?.a1_question || item?.a2_question}</Typography>,
    sortable: true
  };

  const result: any = [
    main,
    {
      id: 'a2_timeToAnswer',
      label: <Title>{t('Time Per Question')}</Title>,
      sortKey: 'a2_timeToAnswer',
      getValue: (item: any) => (
        <Typography>{appendSecondsOrFallback(item.a2_timeToAnswer)}</Typography>
      ),
      sortable: true
    },
    {
      id: 'a2_noOfTries',
      label: <Title>{t('Tries Per Question')}</Title>,
      sortKey: 'a2_noOfTries',
      getValue: (item: any) => (
        <Typography>
          {item.a2_noOfTries}{' '}
          {item?.a2_noOfTries ? (
            <NoTriesIcon current={item.a2_noOfTries} prev={item.a1_noOfTries} />
          ) : (
            'N/A'
          )}
        </Typography>
      ),
      sortable: true
    },
    {
      id: 'a1_timeToAnswer',
      label: <Title>{t('Time Per Question')}</Title>,
      sortKey: 'a1_timeToAnswer',
      getValue: (item: any) => (
        <Typography>{appendSecondsOrFallback(item.a1_timeToAnswer)}</Typography>
      ),
      sortable: true
    },

    {
      id: 'a1_constructAResponse',
      label: <Title>{t('Tries Per Question')}</Title>,
      sortKey: 'a1_noOfTries',
      getValue: (item: any) => (
        <Typography>
          {item?.a1_noOfTries && getDefault(item.a1_noOfTries)}{' '}
          {hasJsonResponse(item) && (
            <IconButton style={{ marginLeft: 100 }} onClick={() => handleIconClick(item)}>
              <InsertDriveFileIcon style={{ color: '#005793' }} />
            </IconButton>
          )}
        </Typography>
      ),
      sortable: true
    }
  ];

  return hasOneAttempt ? filterSingleAttempt(result, activityKey) : result;
};

export default getColumns;
